<template>
  <div class="container">
    <div v-if="hasAttachToMultipleDossiersCapability">
      <button class="btn btn-info btn-sm w-100" @click="goToSearch()">
        Lier à un autre dossier
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.css';
import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import CredentialsStore from '../store/credentials-store'
import { Cabinet, Dossier } from '../interfaces/interfaces'
import { mixins } from 'vue-class-component'
import LysiasApiMixin from '../mixins/LysiasApiMixin'
import SettingsMixin from '../mixins/SettingsMixin'
import Login from './Login.vue';

@Component({ store: CredentialsStore })
export default class Linked extends mixins(LysiasApiMixin, SettingsMixin)
{
  @Watch('isLinked')
  onIsLinked()
  {
    if(!this.isLinked)
    {
      this.$router.push({ name: 'search' });
    }
  }

  get isLinked()
  {
    return this.$store.state.linkedDossiers.length != 0;
  }

  async mounted()
  {
    const mail = Office.context.mailbox.item;
    if(this.hasAttachToMultipleDossiersCapability)
    {
      await this.isMailLinkedToMultipleDossier(mail!);
    }
    else
    {
      await this.isMailLinkedToOneDossier(mail!);
    }
    if(!this.isLinked)
    {
      this.$router.push({ name: 'search' });
    }
  }

  goToSearch()
  {
    this.$router.push({ name: 'search' });
  }
}
</script>
